// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2j_Jp","inputWrap":"Table_inputWrap__i31wd","col":"Table_col__2RmE1","bmiTooltip":"Table_bmiTooltip__1eaNB"};